import { createContext } from "react";

export const ListasCabContext = createContext()
export const ListasCabFormContext = createContext()
export const ListasCabReportContext = createContext()